export enum Category {
  phone = 'phones',
  tablet = 'tablets',
  accessory = 'accessories',
}
